// components/mapas/LegendaCnae.tsx
import React from "react";
import { CNAE_ICONS, CNAE_COLORS } from "./MapaComercio";

// Descrições das seções CNAE
const CNAE_DESCRICOES: Record<string, string> = {
  A: "Agricultura, Pecuária e Florestal",
  B: "Indústrias Extrativas",
  C: "Indústrias de Transformação",
  D: "Eletricidade e Gás",
  E: "Água, Esgoto e Resíduos",
  F: "Construção",
  G: "Comércio",
  H: "Transporte e Logística",
  I: "Alojamento e Alimentação",
  J: "Informação e Comunicação",
  K: "Atividades Financeiras",
  L: "Atividades Imobiliárias",
  M: "Profissionais, Científicas e Técnicas",
  N: "Serviços Administrativos",
  O: "Administração Pública",
  P: "Educação",
  Q: "Saúde",
  R: "Artes, Cultura, Esporte",
  S: "Outros Serviços",
  T: "Serviços Pessoais",
  U: "Organismos Internacionais",
};

export default function LegendaCnae() {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 150,
        right: 10,
        background: "white",
        padding: "12px",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        maxHeight: "40vh",
        overflowY: "auto",
        width: "280px",
        zIndex: 999,
      }}
    >
      <h4 style={{ margin: "0 0 10px 0", fontSize: 16, fontWeight: "bold", color: "#29306a"}}>
        Legenda CNAE
      </h4>

      {Object.keys(CNAE_ICONS).map((secao) => {
        const Icon = CNAE_ICONS[secao];
        const cor = CNAE_COLORS[secao];
        const descricao = CNAE_DESCRICOES[secao];

        return (
          <div
            key={secao}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <div
              style={{
                width: 26,
                height: 26,
                borderRadius: "50%",
                background: cor,
                border: `2px solid ${cor}`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: 8,
              }}
            >
              <Icon size={16} color="white" />
            </div>

            <span style={{ fontSize: 14 }}>{descricao}</span>
          </div>
        );
      })}
    </div>
  );
}
